import ModalWallet from './ModalWallet.jsx';

export default ModalWallet;